import React from "react";
import Spinner from "./Spinner";

const TableBody = ({
  loading,
  data,
  columnsCount,
  emptyMessage = "No records found.",
  loadingMessage = "Loading...",
  renderRow,
}) => (
  <tbody className="bg-white divide-y divide-gray-200">
    {loading ? (
      <tr>
        <td colSpan={columnsCount} className="text-center py-8 text-gray-400">
          <div className="flex justify-center items-center">
            <Spinner text={loadingMessage} className="text-btn-primary" />
          </div>
        </td>
      </tr>
    ) : data && data.length > 0 ? (
      data.map(renderRow)
    ) : (
      <tr>
        <td colSpan={columnsCount} className="text-center py-6 text-gray-400">
          {emptyMessage}
        </td>
      </tr>
    )}
  </tbody>
);

export default TableBody;